export default {
  SET_INIT_STATE_LOADED: "SET_INIT_STATE_LOADED",
  SET_PLAYERS_AND_TEAMS: "SET_PLAYERS_AND_TEAMS",
  SET_USER: "SET_USER",
  SET_ALERTS: "SET_ALERTS",
  SET_NAV_NOTIFICATIONS: "SET_NAV_NOTIFICATIONS",
  SET_ORG_UNIT_SELECTION: "SET_ORG_UNIT_SELECTION"
};
